import React from "react";

const colors = {
  healthy: "#16a34a",
  degraded: "#d97706",
  offline: "#9ca3af",
};

export default function StatusBadge({ status }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "2px 10px",
        borderRadius: "12px",
        fontSize: "12px",
        fontWeight: 600,
        backgroundColor: `${colors[status] || colors.offline}18`,
        color: colors[status] || colors.offline,
      }}
    >
      <span
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: colors[status] || colors.offline,
        }}
      />
      {status}
    </span>
  );
}
